import { render, staticRenderFns } from "./userRoleListDialog.vue?vue&type=template&id=c6e24f74&scoped=true"
import script from "./userRoleListDialog.vue?vue&type=script&lang=js"
export * from "./userRoleListDialog.vue?vue&type=script&lang=js"
import style0 from "./userRoleListDialog.vue?vue&type=style&index=0&id=c6e24f74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6e24f74",
  null
  
)

export default component.exports